/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import classes from "./sass/TimeCardInsightReportDetail.module.scss";
import { usePermission } from "../../../hooks/usePermission.js";
import { PERMISSIONS } from "../../../consts/api.js";
import { DeleteTimeLog } from "./DeleteTimeLog/DeleteTimeLog.js";
import { TriangleAlertIcon } from "../../../assets/Icons/TriangleAlertIcon.js";
import {
  numberFormat,
  getTimeFormat,
  showFormattedDate,
} from "../../../Utils/services.js";
import { Button } from "../../../shared/Button/Button.js";
import ClockInData from "./TimeCardInsightReportDetail/ClockInData.js";
import ClockOutData from "./TimeCardInsightReportDetail/ClockOutData.js";
import TrackedAs from "./TimeCardInsightReportDetail/TrackedAs.js";
import SplitTime from "./SplitTime/SplitTime.js";

const TIME_LOG_MODES = {
  manual: "manual",
};

class TimeCardInsightReportDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeFormat: getTimeFormat(),
      isEditingClockIn: false,
      detailData: this.props.detailData,
      userData: JSON.parse(localStorage.getItem("userData")),
      updatedTimeTracking: false,
      updatedTimeTrackingTimestamp: null,
      expandedRowsIndexes: [],
      editClock: null,
    };
    window.onscroll = () => {
      return false;
    };
    this.calendarRef = React.createRef();
  }

  static getDerivedStateFromProps(props, state) {
    let returnState = {};
    if (
      props.detailData &&
      state.detailData &&
      JSON.stringify(props.detailData) !== JSON.stringify(state.detailData)
    ) {
      returnState.detailData = props.detailData;
    }
    if (
      props.updatedTimeTracking &&
      props.updatedTimeTrackingTimestamp &&
      props.updatedTimeTrackingTimestamp !==
        state.updatedTimeTrackingTimestamp &&
      props.detailProviderId &&
      props.detailProviderName
    ) {
      returnState.updatedTimeTrackingTimestamp =
        props.updatedTimeTrackingTimestamp;
      props.fetchTimeCardReportDetails({
        detailProviderId: props.detailProviderId,
        detailProviderName: props.detailProviderName,
      });
    }
    return returnState;
  }

  timeCardPracticeBack = () => {
    this.props.timeCardPracticeBack();
  };

  handleDetailExport = () => {
    this.props.fetchTimeCardReportDetails(
      {
        export_name: "time_card_practice_details",
        export_type: "xls",
        detailProviderId: this.props.detailProviderId,
        detailProviderName: this.props.detailProviderName,
      },
      1,
    );
  };

  refetchLogs = () => {
    this.props.fetchTimeCardReportDetails({
      detailProviderId: this.props.detailProviderId,
      detailProviderName: this.props.detailProviderName,
    });
  };

  handleDateChangeRaw = (e) => {
    e.preventDefault();
  };

  get detailData() {
    return Object.values(this.state.detailData);
  }

  handleExpandRow = (index) => {
    if (this.state.expandedRowsIndexes.includes(index)) {
      this.setState({
        expandedRowsIndexes: this.state.expandedRowsIndexes.filter(
          (i) => i !== index,
        ),
      });
      return;
    }
    this.setState({
      expandedRowsIndexes: [...this.state.expandedRowsIndexes, index],
    });
  };

  render() {
    const userPrivileges =
      this.state.userData && this.state.userData.permissions
        ? this.state.userData.permissions
        : [];
    const isLogPermitted = Boolean(this.props.isLogPermitted);

    return (
      <div className="setting-setion m-b-10">
        <div className="table-responsive clients-table">
          <table className="table-updated setting-table table-min-width no-td-border  no-hover">
            <thead className="table-updated-thead">
              <tr>
                <th className="table-updated-th">Day</th>
                <th className="table-updated-th">Hours</th>
                <th className="table-updated-th">Category</th>
                <th className="table-updated-th">Clock In</th>
                <th className="table-updated-th">Clock Out</th>
                {isLogPermitted && (
                  <th className="table-updated-th max-w-30">Action</th>
                )}
              </tr>
            </thead>
            <tbody className="ajax_body">
              {this.detailData?.length > 0 &&
                this.detailData.map((el, index) => (
                  <Fragment key={index}>
                    <tr className="table-updated-tr" key={index}>
                      <td className="table-updated-td bold">{el.day}</td>
                      <td className="table-updated-td bold">
                        {el.total_hours}
                      </td>
                      <td className="table-updated-td bold">Time Category</td>
                      <td className="table-updated-td bold">
                        {showFormattedDate(
                          el.clock_in,
                          true,
                          "",
                          "YYYY-MM-DD HH:mm:ss",
                        )}
                      </td>
                      <td className="table-updated-td bold">
                        {showFormattedDate(
                          el.clock_out,
                          true,
                          "",
                          "YYYY-MM-DD HH:mm:ss",
                        )}
                      </td>
                      <td className="table-updated-td">
                        <Button
                          onClick={() => this.handleExpandRow(index)}
                          size="tiny"
                        >
                          {this.state.expandedRowsIndexes.includes(index)
                            ? "Hide Details"
                            : "View Details"}
                        </Button>
                      </td>
                    </tr>
                    {this.state.expandedRowsIndexes.includes(index) &&
                      el.details.map((detail) => {
                        return (
                          <tr key={detail.id} className="table-updated-tr">
                            <td className="table-updated-td break-all">
                              <div className={classes.dayTd}>
                                <div className={classes.dayName}>
                                  {detail.day}
                                  {!!detail.is_overtime && (
                                    <div className={classes.overtime}>
                                      Overtime
                                      <TriangleAlertIcon width="16px" />
                                    </div>
                                  )}
                                </div>
                                {detail.mode === TIME_LOG_MODES.manual && (
                                  <div className={classes.manualChip}>
                                    Manual
                                  </div>
                                )}
                              </div>
                            </td>
                            <td className="table-updated-td">
                              {detail.total_hours || "0"}
                            </td>
                            <td className="table-updated-td">
                              <TrackedAs
                                detail={detail}
                                availableTrackAs={this.props.availableTrackAs}
                              />
                            </td>
                            <td className="table-updated-td">
                              <ClockInData
                                detail={detail}
                                userPrivileges={userPrivileges}
                              />
                            </td>
                            <td className="table-updated-td">
                              <ClockOutData
                                detail={detail}
                                userPrivileges={userPrivileges}
                              />
                            </td>
                            {isLogPermitted && (
                              <td className="table-updated-td max-w-30">
                                <div className={classes.actionButtons}>
                                  <SplitTime
                                    detail={detail}
                                    refetchLogs={this.refetchLogs}
                                    availableTrackAs={
                                      this.props.availableTrackAs
                                    }
                                  />
                                  <DeleteTimeLog
                                    id={detail.id}
                                    refetchLogs={this.refetchLogs}
                                  />
                                </div>
                              </td>
                            )}
                          </tr>
                        );
                      })}
                  </Fragment>
                ))}
              {this.detailData.length === 0 && (
                <tr className="table-updated-tr">
                  <td
                    className="table-updated-td no-record no-float"
                    colSpan="5"
                  >
                    {this.props.businessInsightLang.bi_no_record_found}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {this.detailData.length > 0 && (
          <div className="TimeCardTotalHours">
            <div className="detail-row">
              <label className="no-margin">Total Hours:</label>
              <span>
                {this.props.detailTotal && this.props.detailTotal.total_hours
                  ? this.props.detailTotal.total_hours
                  : "0"}
              </span>
            </div>
            <div className="detail-row">
              <label className="no-margin">Pay per Hour:</label>
              <span>
                {numberFormat(
                  this.props.detailTotal && this.props.detailTotal.hourly_rate
                    ? this.props.detailTotal.hourly_rate
                    : 0,
                  "currency",
                )}
              </span>
            </div>
            <div className="detail-row">
              <label className="no-margin">Total Gross Pay:</label>
              <span>
                {numberFormat(
                  this.props.detailTotal &&
                    this.props.detailTotal.total_gross_pay
                    ? this.props.detailTotal.total_gross_pay
                    : 0,
                  "currency",
                )}
              </span>
            </div>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const returnState = {};

  if (state.BusinessInsightReducer.action === "UPDATE_TIME_TRACKING") {
    if (state.BusinessInsightReducer.data.status === 200) {
      returnState.updatedTimeTracking = true;
      returnState.updatedTimeTrackingTimestamp = new Date().getTime();
    }
  }
  return returnState;
}

const withIsLogPermitted = (Component) => {
  return function Wrapper(props) {
    const logPermission = usePermission(
      PERMISSIONS.businessInsights.manualTimeLog,
    );
    return (
      <Component
        {...props}
        isLogPermitted={logPermission.loaded && logPermission.permitted}
      />
    );
  };
};

export default connect(
  mapStateToProps,
  null,
)(withIsLogPermitted(TimeCardInsightReportDetail));
